import React from "react";
import moment from "moment";
import { Table, Thead, Tbody, Tr, Th, Td } from "ui-kit-ck-consultant";

const DAY_LABELS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export const SOURCE_LABELS = {
  manual: "Pris par le cabinet (ixperience)",
  pilotage: "Pris ici",
  wizard: "Pris par l'assuré (formulaire)",
  link: "Pris par l'assuré (lien SMS)",
};

// House colours (ui-kit css/style.css), one per way of booking a slot.
export const SOURCE_COLORS = {
  manual: "bg-blue white",
  pilotage: "bg-purple white",
  wizard: "bg-green white",
  link: "bg-orange white",
};

/**
 * The week of one agency: its opening hours as rows, the days as columns.
 *
 * The grid is served by ixperience, which builds it from ck2020_agency.a_time —
 * the cabinet must be offered exactly the slots the insured is offered, and two
 * readings of that JSON would drift apart.
 */
export default class WeekGrid extends React.Component {
  appointmentAt = (date, hour) =>
    this.props.appointments.find((item) => item.date === date && item.hour === hour);

  renderCell(day, hour) {
    const appointment = this.appointmentAt(day.date, hour);
    if (!appointment && (!day.open || !day.free.includes(hour))) {
      return <Td className="bg-gray-light" key={`${day.date}-${hour}`} />;
    }

    if (!appointment) {
      return (
        <Td
          key={`${day.date}-${hour}`}
          className="bg-green-light cursor-pointer"
          onClick={() => this.props.onFreeSlot(day.date, hour)}
        />
      );
    }

    return (
      <Td
        key={`${day.date}-${hour}`}
        className={`${SOURCE_COLORS[appointment.source] || "bg-gray white"} cursor-pointer`}
        onClick={() => this.props.onAppointment(appointment)}
      >
        <span
          className="AppointmentGrid-line"
          title={`${appointment.reference} — ${appointment.nameClient || ""}`}
        >
          <b>{appointment.reference}</b>
        </span>
        <span className="AppointmentGrid-line">
          {[appointment.kindClient, appointment.nameClient].filter(Boolean).join(" ")}
        </span>
      </Td>
    );
  }

  render() {
    const { days } = this.props;
    // The rows are the agency's slots, plus any booked hour off that grid: an
    // appointment taken on an older grid still has to show.
    const hours = [
      ...new Set([
        ...days.filter((day) => day.open).reduce((all, day) => all.concat(day.slots), []),
        ...this.props.appointments.map((item) => item.hour),
      ]),
    ].sort();

    if (!hours.length) {
      return (
        <p className="text-center mt-20 mb-20">
          Aucun horaire d'ouverture n'est renseigné pour cette agence : personne ne peut prendre de
          rendez-vous tant qu'il n'y en a pas. Les horaires se saisissent dans Tournées, colonne
          « RDV agence ».
        </p>
      );
    }

    return (
      <div className="AppointmentGrid">
        <Table>
          <Thead>
            <Tr>
              <Th>Horaire</Th>
              {days.map((day) => (
                <Th key={day.date}>
                  {DAY_LABELS[moment(day.date).isoWeekday() - 1]}
                  <br />
                  {moment(day.date).format("DD/MM")}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {hours.map((hour) => (
              <Tr key={hour}>
                <Th>{hour}</Th>
                {days.map((day) => this.renderCell(day, hour))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    );
  }
}
